import clsx from 'clsx';
import { Title } from '../Title';
import * as style from './RentProfit.css';
import { RENT_PROFIT } from 'shared/constants/rentProfit';
import { useDeviceType } from '@cian/ui-kit';

export const RentProfit: React.FC = () => {
  const device = useDeviceType();

  return (
    <div
      id="howWeWorking"
      className={clsx(
        style['container'],
        device !== 'desktop' && style['container-tablet'],
        device === 'phone' && style['container-phone'],
      )}
    >
      <div className={style['title']}>
        <Title>Сдайте квартиру выгодно</Title>
      </div>
      <div className={style['list']}>
        {RENT_PROFIT.map(({ id, title, description }) => (
          <div key={id} className={style['item-wrapper']}>
            <div className={clsx(style['item'])}>
              <div className={style['front']}>
                <div className={style['number']}>{id}</div>
                <div className={style['item-title']}>{title}</div>
              </div>
              <div className={style['back']}>
                <div className={style['descr']}>
                  {description.map((item, index) => (
                    <div key={index} className={style['text']}>
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
